export default "__VITE_ASSET__CMe4ook0__"